import { BaseAction } from './BaseAction';
import Locale from '../../utils/Locale';
import * as Alert from '../../alert';

let alertTypes = {};
for (let cls of Object.values(Alert.Types)) {
    if (!cls.type || cls.type.length === 0)
        continue;
    let types = Array.isArray(cls.type) ? cls.type : [cls.type];
    for (let type of types) {
        let title = Array.isArray(cls.type) ? 
            cls.title[types.indexOf(type)] : 
            cls.title;
        if (cls) {
            alertTypes[type] = title;
        }
    }
}

export class AlertClosed extends BaseAction {
    public static getTitle:Function = () => Locale.gettext('Alert Resolved');
    public static getDescription:Function = () => Locale.gettext('When an alert is resolved');
    public static deviceLevel:boolean = true;
    public static categories: { [key: string]: string; } = Alert.AlertCategories;
    public static types: { [key: string]: string; } = alertTypes;
    public static supportedRoutes:string[] = [ "push", "email" ];
}